export default __webpack_public_path__ + "static/media/mixed-flow-icon.3584fa19.svg";